module.exports = __webpack_public_path__ + "fonts/537b145a-6a7d-4787-81d9-7228d3a42458.06730a10.woff";